import { SET_LEVEL_INFO, SET_UNITS } from './action_types';

export const setLevelData = (data) => ({
  type: SET_LEVEL_INFO,
  payload: data,
});

export const setUnits = (data) => ({
  type: SET_UNITS,
  payload: data,
});
